export default __webpack_public_path__ + "static/media/wippy_download_page_bg_ko.424703c9.jpg";